// extracted by mini-css-extract-plugin
module.exports = {"container":"Imagem_container__1UdZn","imagem":"Imagem_imagem__3S8Tt","info":"Imagem_info__2RJU0","descricao":"Imagem_descricao__2vI2P","opcoes":"Imagem_opcoes__3ndVL"};